import HttpHelpers from '../helpers';

const EntitiesApiEndpoints = {
  getEntities: (listingId) => {
    return HttpHelpers.authenticatedAxios
      .get(`host/listing/${listingId}/entity`)
      .then((response) => response.data);
  },
  createEntity: (listingId, data) => {
    return HttpHelpers.authenticatedAxios
      .post(`host/listing/${listingId}/entity`, data)
      .then((response) => response.data);
  },
  updateEntity: (listingId, entityId, data) => {
    return HttpHelpers.authenticatedAxios
      .patch(`host/listing/${listingId}/entity/${entityId}`, data)
      .then((response) => response.data);
  },
  deleteEntity: (listingId, entityId) => {
    return HttpHelpers.authenticatedAxios
      .delete(`host/listing/${listingId}/entity/${entityId}`)
      .then((response) => response.data);
  },
};

export default EntitiesApiEndpoints;
